/* ============ Shimco · galeria.js ============ */
(function () {
  'use strict';

  var gal = document.querySelector('[data-gal]');
  if (!gal) return;

  var track    = gal.querySelector('[data-gal-track]');
  var slides   = Array.prototype.slice.call(gal.querySelectorAll('[data-gal-slide]'));
  var thumbs   = Array.prototype.slice.call(gal.querySelectorAll('[data-gal-thumb]'));
  var dots     = Array.prototype.slice.call(gal.querySelectorAll('[data-gal-dot]'));
  var contador = gal.querySelector('[data-gal-actual]');
  var btnPrev  = gal.querySelector('[data-gal-prev]');
  var btnNext  = gal.querySelector('[data-gal-next]');
  var lupa     = gal.querySelector('[data-gal-lupa]');

  var actual = 0;
  if (!slides.length) return;

  /* ---------- Navegacion ---------- */
  function marcar(i) {
    actual = i;
    thumbs.forEach(function (t, n) {
      if (n === i) { t.setAttribute('aria-current', 'true'); }
      else { t.removeAttribute('aria-current'); }
    });
    dots.forEach(function (d, n) {
      if (n === i) { d.setAttribute('aria-current', 'true'); }
      else { d.removeAttribute('aria-current'); }
    });
    if (contador) contador.textContent = i + 1;
    if (btnPrev) btnPrev.disabled = i === 0;
    if (btnNext) btnNext.disabled = i === slides.length - 1;
  }

  window.shGaleriaIr = function (i) {
    if (i < 0 || i > slides.length - 1) return;
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    marcar(i);
  };

  window.shGaleriaPorMedia = function (mediaId) {
    var n = -1;
    slides.forEach(function (s, i) { if (s.dataset.mediaId == mediaId) n = i; });
    if (n >= 0) window.shGaleriaIr(n);
  };

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { window.shGaleriaIr(Number(t.dataset.galThumb)); });
  });
  dots.forEach(function (d) {
    d.addEventListener('click', function () { window.shGaleriaIr(Number(d.dataset.galDot)); });
  });
  if (btnPrev) btnPrev.addEventListener('click', function () { window.shGaleriaIr(actual - 1); });
  if (btnNext) btnNext.addEventListener('click', function () { window.shGaleriaIr(actual + 1); });

  var st;
  track.addEventListener('scroll', function () {
    clearTimeout(st);
    st = setTimeout(function () {
      var centro = track.scrollLeft + track.clientWidth / 2;
      var cerca = 0, min = Infinity;
      slides.forEach(function (s, n) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft + s.clientWidth / 2 - centro);
        if (d < min) { min = d; cerca = n; }
      });
      if (cerca !== actual) marcar(cerca);
    }, 90);
  }, { passive: true });

  /* ---------- Arrastre con el mouse ---------- */
  var arrastrando = false, xInicio = 0, scrollInicio = 0, movio = false;

  track.addEventListener('mousedown', function (e) {
    arrastrando = true; movio = false;
    xInicio = e.pageX;
    scrollInicio = track.scrollLeft;
    track.classList.add('is-dragging');
  });
  window.addEventListener('mousemove', function (e) {
    if (!arrastrando) return;
    var dx = e.pageX - xInicio;
    if (Math.abs(dx) > 4) movio = true;
    track.scrollLeft = scrollInicio - dx;
  });
  window.addEventListener('mouseup', function () {
    if (!arrastrando) return;
    arrastrando = false;
    track.classList.remove('is-dragging');
    window.shGaleriaIr(actual);
  });

  /* ---------- Zoom con el cursor ---------- */
    /* ---------- Zoom opcional con el cursor ---------- */
  var zoomActivo = false;

  if (lupa) {
    lupa.addEventListener('click', function (e) {
      e.stopPropagation();
      zoomActivo = !zoomActivo;
      gal.classList.toggle('zoom-on', zoomActivo);
      lupa.classList.toggle('is-activa', zoomActivo);
      lupa.setAttribute('aria-label', zoomActivo ? 'Desactivar zoom' : 'Activar zoom');
      if (!zoomActivo) {
        slides.forEach(function (s) {
          s.classList.remove('is-zoom');
          var im = s.querySelector('[data-gal-img]');
          if (im) im.style.transformOrigin = 'center center';
        });
      }
    });
  }

  if (window.matchMedia('(hover: hover)').matches) {
    slides.forEach(function (slide) {
      var img = slide.querySelector('[data-gal-img]');
      if (!img) return;

      slide.addEventListener('mousemove', function (e) {
        if (!zoomActivo || arrastrando || !slide.classList.contains('is-zoom')) return;
        var r = slide.getBoundingClientRect();
        img.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' +
          ((e.clientY - r.top) / r.height * 100) + '%';
      });

      slide.addEventListener('mouseenter', function () {
        if (zoomActivo) slide.classList.add('is-zoom');
      });
      slide.addEventListener('mouseleave', function () {
        slide.classList.remove('is-zoom');
        img.style.transformOrigin = 'center center';
      });
    });
  }

  /* ---------- Visor a pantalla completa ---------- */
  var lb = document.querySelector('[data-lb]');
  if (!lb) { marcar(0); return; }

  var lbImg = lb.querySelector('[data-lb-img]');
  var escala = 1, tx = 0, ty = 0;

  function pintarLb() {
    lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + escala + ')';
    lb.classList.toggle('is-zoom', escala > 1);
  }

  function abrirLb(i) {
    var img = slides[i].querySelector('[data-gal-img]');
    if (!img) return;
    lbImg.src = img.dataset.full || img.src;
    lbImg.alt = img.alt;
    escala = 1; tx = 0; ty = 0; pintarLb();
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function cerrarLb() {
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
  }


  slides.forEach(function (slide, i) {
    slide.addEventListener('click', function () {
      if (movio) return;
      abrirLb(i);
    });
  });

  lb.querySelector('[data-lb-cerrar]').addEventListener('click', cerrarLb);
  lb.addEventListener('click', function (e) { if (e.target === lb) cerrarLb(); });

  lb.querySelector('[data-lb-prev]').addEventListener('click', function (e) {
    e.stopPropagation();
    if (actual > 0) { window.shGaleriaIr(actual - 1); abrirLb(actual); }
  });
  lb.querySelector('[data-lb-next]').addEventListener('click', function (e) {
    e.stopPropagation();
    if (actual < slides.length - 1) { window.shGaleriaIr(actual + 1); abrirLb(actual); }
  });

  lbImg.addEventListener('dblclick', function (e) {
    e.stopPropagation();
    if (escala > 1) { escala = 1; tx = 0; ty = 0; }
    else { escala = 2.4; }
    pintarLb();
  });

  lb.addEventListener('wheel', function (e) {
    if (!lb.classList.contains('is-open')) return;
    e.preventDefault();
    escala = Math.min(4, Math.max(1, escala - e.deltaY * 0.0018));
    if (escala === 1) { tx = 0; ty = 0; }
    pintarLb();
  }, { passive: false });

  var punteros = new Map(), distIni = 0, escalaIni = 1, panX = 0, panY = 0;

  lbImg.addEventListener('pointerdown', function (e) {
    lbImg.setPointerCapture(e.pointerId);
    punteros.set(e.pointerId, e);
    if (punteros.size === 2) {
      var p = Array.from(punteros.values());
      distIni = Math.hypot(p[0].clientX - p[1].clientX, p[0].clientY - p[1].clientY);
      escalaIni = escala;
    } else {
      panX = e.clientX - tx;
      panY = e.clientY - ty;
    }
  });

  lbImg.addEventListener('pointermove', function (e) {
    if (!punteros.has(e.pointerId)) return;
    punteros.set(e.pointerId, e);

    if (punteros.size === 2) {
      var p = Array.from(punteros.values());
      var d = Math.hypot(p[0].clientX - p[1].clientX, p[0].clientY - p[1].clientY);
      escala = Math.min(4, Math.max(1, escalaIni * (d / distIni)));
      pintarLb();
    } else if (escala > 1) {
      tx = e.clientX - panX;
      ty = e.clientY - panY;
      pintarLb();
    }
  });

  function soltar(e) {
    punteros.delete(e.pointerId);
    if (punteros.size < 2) distIni = 0;
    if (escala <= 1) { escala = 1; tx = 0; ty = 0; pintarLb(); }
  }
  lbImg.addEventListener('pointerup', soltar);
  lbImg.addEventListener('pointercancel', soltar);

  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') cerrarLb();
    if (e.key === 'ArrowLeft' && actual > 0) { window.shGaleriaIr(actual - 1); abrirLb(actual); }
    if (e.key === 'ArrowRight' && actual < slides.length - 1) { window.shGaleriaIr(actual + 1); abrirLb(actual); }
  });

  marcar(0);
})();